{
  "name": "hc-airlines-dg-claims-app",
  "version": "1.146.0",
  "scripts": {
    "ng": "ng",
    "build": "ng build",
    "start-local": "ng serve --configuration=local",
    "start-test": "ng serve --configuration=test",
    "start-dev": "ng serve --configuration=development",
    "start-staging": "ng serve --configuration=staging",
    "start-production": "ng serve --configuration=production",
    "prepare": "husky install",
    "preview-e2e": "pnpm msw init src --no-save && pnpm ng build --configuration=test && pnpm http-server ./dist/hc-airlines-dg-claims-app -p 4200",
    "check-i18n": "pnpm tsx src/app/shared/i18n/i18n-validation.ts",
    "test": "ng test",
    "test-e2e": "pnpm exec playwright test",
    "format": "prettier --config ./.prettierrc --write .",
    "format:check": "prettier --config ./.prettierrc --check ."
  },
  "packageManager": "pnpm@9.15.2",
  "private": true,
  "dependencies": {
    "@angular/animations": "~19.2.5",
    "@angular/cdk": "^19.2.8",
    "@angular/cli": "^19.2.6",
    "@angular/common": "~19.2.5",
    "@angular/compiler": "~19.2.5",
    "@angular/core": "~19.2.5",
    "@angular/forms": "~19.2.5",
    "@angular/material": "^19.2.8",
    "@angular/material-date-fns-adapter": "^19.2.8",
    "@angular/platform-browser": "~19.2.5",
    "@angular/platform-browser-dynamic": "~19.2.5",
    "@angular/router": "~19.2.5",
    "@datadog/browser-logs": "^5.31.1",
    "@datadog/browser-rum": "^5.31.1",
    "@date-fns/utc": "2.1.0",
    "@hts/partner-airlines-api-client": "^1.0.137",
    "@ngrx/router-store": "^19.1.0",
    "@ngrx/store": "^19.1.0",
    "@ngrx/store-devtools": "^19.1.0",
    "@ngx-translate/core": "^16.0.3",
    "date-fns": "^4.1.0",
    "hc-airlines-dg-claims-app": "link:",
    "husky": "9.1.7",
    "i18n-iso-countries": "^7.14.0",
    "lodash": "^4.17.21",
    "msw": "^2.7.3",
    "nanoid": "^5.1.5",
    "ngrx-store-freeze": "^0.2.4",
    "ngx-otp-input": "1.1.2",
    "rxjs": "~7.8.1",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~19.2.6",
    "@angular/compiler-cli": "~19.2.5",
    "@playwright/test": "^1.49.0",
    "@types/jasmine": "~5.1.4",
    "@types/lodash": "^4.17.13",
    "@types/node": "^22.9.3",
    "@types/node-forge": "^1.3.11",
    "ajv": "^8.17.1",
    "http-proxy-middleware": "3.0.5",
    "http-server": "^14.1.1",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.2.10",
    "node-forge": "^1.3.1",
    "playwright": "^1.49.0",
    "prettier": "^3.3.3",
    "puppeteer": "^24.12.1",
    "tsx": "^4.19.2",
    "type-fest": "^4.18.3",
    "typescript": "~5.8.3"
  },
  "msw": {
    "workerDirectory": "src"
  },
  "engines": {
    "node": ">=20 <22"
  },
  "lint-staged": {
    "*.{json,md,html,js,jsx,ts,tsx}": [
      "pnpm format"
    ]
  },
  "pnpm": {
    "overrides": {
      "cross-spawn@7": "^7.0.5",
      "tar-fs": ">=3.0.9",
      "vite": "6.2.7",
      "http-proxy-middleware": "3.0.5"
    }
  }
}
